// @flow
import type {ApplicationRedux} from 'redux/ApplicationRedux';
import type {NoticeState} from 'redux/v1/customerNotice/notice/NoticeState';
import type {PutState} from 'redux/v1/customerNotice/put/PutState';

import {customerNoticeState} from 'redux/v1/V1State';

export type CustomerNoticeState = {
  notice: NoticeState,
  put: PutState,
};

export const noticeState = (state: ApplicationRedux): NoticeState =>
  customerNoticeState(state).notice;

export const putState = (state: ApplicationRedux): PutState =>
  customerNoticeState(state).put;
